export function 
showAlert
(
  message = "",              // ✅ DEFAULT BLANK
  redirectUrl = "/login",    // ✅ DEFAULT LOGIN
  type = "success"
) 
{
  // Show popup only if message exists
  if (message) 
  {
    alert(message);
  }

  // Redirect (always, unless explicitly disabled)
  if (redirectUrl) 
  {
    window.location.href = redirectUrl;
  }
}